// Linha do tempo unificada da order: eventos das 4 fontes (ML âmbar, MP azul,
// extrato teal, NF-e violeta) em ordem cronológica. Eventos-problema ganham
// anel vermelho; previstos (liberação futura) aparecem tracejados.
import { FormatPrice } from '../../utils/format';

const DOT = {
    ml: 'bg-amber-500',
    mp: 'bg-[#3483fa]',
    ext: 'bg-teal-500',
    nfe: 'bg-violet-500',
};
const SOURCE_LABEL = { ml: 'ML', mp: 'MP', ext: 'Extrato', nfe: 'NF-e' };

// valor absoluto (o sinal vem do tipo do evento); dateTime curto é o formato
// próprio da timeline (ano 2 dígitos), mantido local de propósito.
const money = (v) => FormatPrice(Math.abs(Number(v) || 0));
const dateTime = (v) => (v ? new Date(v).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—');

export default function OrderTimeline({ timeline }) {
    if (!timeline?.length) {
        return <p className="text-sm text-mono-400">Sem eventos registrados ainda.</p>;
    }
    return (
        <ol className="relative ml-2 space-y-0.5 border-l border-mono-200 pl-4 dark:border-mono-700">
            {timeline.map((e, i) => {
                const problem = e.kind === 'problem';
                const forecast = e.kind === 'forecast';
                const muted = e.kind === 'muted';
                return (
                    <li key={`${e.ts}-${e.label}-${i}`} className={`relative py-1 ${muted ? 'opacity-60' : ''}`}>
                        <span
                            className={`absolute -left-[21.5px] top-2 h-2.5 w-2.5 rounded-full ${forecast ? 'border-2 border-mono-400 bg-transparent' : DOT[e.source] || 'bg-mono-400'} ${problem ? 'ring-2 ring-red-500 ring-offset-1 dark:ring-offset-mono-900' : ''}`}
                            title={SOURCE_LABEL[e.source] || e.source}
                        />
                        <div className="flex flex-wrap items-baseline gap-x-2 text-sm">
                            <span className="whitespace-nowrap font-mono text-xs text-mono-400">{dateTime(e.ts)}</span>
                            <span className={`font-mono text-[10px] uppercase ${forecast ? 'text-mono-400' : 'text-mono-500'}`}>
                                {SOURCE_LABEL[e.source] || e.source}
                            </span>
                            <span className={`${problem ? 'font-semibold text-red-600 dark:text-red-400' : ''} ${forecast ? 'italic text-mono-400' : ''}`}>
                                {e.label}
                                {forecast ? ' (previsto)' : ''}
                            </span>
                            {e.amount != null && Number(e.amount) !== 0 ? (
                                <span
                                    className={`ml-auto font-mono tabular-nums ${e.source === 'nfe' ? 'text-mono-500' : Number(e.amount) < 0 ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}`}
                                >
                                    {e.source === 'nfe' ? '' : Number(e.amount) < 0 ? '− ' : '+ '}
                                    {money(e.amount)}
                                </span>
                            ) : null}
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}
